import PropTypes from 'prop-types';
import { moneyFormatter } from 'domain-model';

export default function Money(props) {
  const { value, leaveBlank, id, currency } = props;

  if (leaveBlank && !value) {
    return <span id={id} />;
  }

  return (
    <span className="text-nowrap" id={id}>
      {moneyFormatter.longForm(value, currency)}
    </span>
  );
}

Money.propTypes = {
  value: PropTypes.number,
  id: PropTypes.string,
  currency: PropTypes.string,
  leaveBlank: PropTypes.bool,
};

Money.defaultProps = {
  value: 0,
  id: undefined,
  currency: 'SEK',
  leaveBlank: false,
};
